export default function InstagramSection() {
  const reels = [
    {
      id: 1,
      url: "https://www.instagram.com/reel/DYndiHPPO1j",
      image:
        "https://static.readdy.ai/image/d70d14e642c2c6f5d3cb475f694c0196/8126e33633b43070b86c57ce5d454250.jpeg",
      title: "See It in Action",
      duration: "0:15",
    },
    {
      id: 2,
      url: "https://www.instagram.com/reel/DYr9J4biq1T",
      image:
        "https://static.readdy.ai/image/d70d14e642c2c6f5d3cb475f694c0196/f87f45518309fbc5eef693e34fb851ef.jpeg",
      title: "Cat Approved",
      duration: "0:22",
    },
  ];

  return (
    <section id="instagram" className="w-full bg-white py-20 md:py-28">
      <div className="w-full px-6 md:px-12 lg:px-20">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-10 md:mb-14">
            <div>
              <div className="flex items-center gap-3 mb-3">
                <span className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-gradient-to-tr from-yellow-400 via-rose-500 to-purple-600">
                  <i className="ri-instagram-line text-white text-sm" />
                </span>
                <span className="text-xs font-medium text-stone-400 tracking-widest uppercase">
                  Follow Us on Instagram
                </span>
              </div>
              <h2 className="text-2xl md:text-4xl font-semibold text-stone-900">
                Real Cats, <span className="text-rose-700">Real Moments</span>
              </h2>
              <p className="mt-2 text-sm md:text-base text-stone-500 max-w-xl">
                Watch how cats everywhere are loving their Purrfect Pinot Noir
                scratcher. Tag us to get featured!
              </p>
            </div>
            <a
              href="https://www.instagram.com/purrfectpinotnoir/"
              target="_blank"
              rel="noopener noreferrer"
              className="hidden md:inline-flex items-center gap-2 mt-4 md:mt-0 px-5 py-2.5 border border-stone-200 text-stone-700 text-sm font-medium rounded-full hover:bg-stone-50 transition-colors whitespace-nowrap"
            >
              <i className="ri-instagram-line text-rose-600" />
              @purrfectpinotnoir
            </a>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 md:gap-8">
            {reels.map((reel) => (
              <a
                key={reel.id}
                href={reel.url}
                target="_blank"
                rel="noopener noreferrer"
                className="group relative block rounded-2xl overflow-hidden bg-stone-100 aspect-[4/5]"
              >
                <img
                  src={reel.image}
                  alt={reel.title}
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />

                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />

                <div className="absolute top-4 left-4 flex items-center gap-2">
                  <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-white/90 backdrop-blur-sm rounded-full text-xs font-semibold text-stone-900">
                    <i className="ri-movie-fill text-rose-600" />
                    REEL
                  </span>
                  <span className="px-3 py-1.5 bg-black/60 backdrop-blur-sm rounded-full text-xs font-medium text-white">
                    {reel.duration}
                  </span>
                </div>

                <div className="absolute bottom-0 left-0 right-0 p-5 md:p-7">
                  <h3 className="text-lg md:text-xl font-semibold text-white mb-1">
                    {reel.title}
                  </h3>
                  <div className="flex items-center gap-2 text-white/70 text-sm">
                    <span className="w-5 h-5 rounded-full bg-white/20 flex items-center justify-center">
                      <i className="ri-play-fill text-white text-xs" />
                    </span>
                    Watch on Instagram
                  </div>
                </div>

                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <span className="w-16 h-16 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center border border-white/30">
                    <i className="ri-play-fill text-white text-2xl ml-1" />
                  </span>
                </div>
              </a>
            ))}
          </div>

          <div className="mt-8 text-center md:hidden">
            <a
              href="https://www.instagram.com"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-5 py-2.5 border border-stone-200 text-stone-700 text-sm font-medium rounded-full hover:bg-stone-50 transition-colors whitespace-nowrap"
            >
              <i className="ri-instagram-line text-rose-600" />
              @purrfectpinotnoir
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}